const admins = [
    'guruji@gmail.com'
];
export default admins